(() => {
  let controller;
  let observer;
  let frame;
  let rebindFrame;
  let activeHeader;
  let activeBanner;
  const init = () => {
    controller?.abort();
    observer?.disconnect();
    cancelAnimationFrame(frame);
    frame = null;
    const header = document.querySelector('.shopify-section-header');
    activeHeader = header;
    activeBanner = null;
    if (!header) return;
    const main = document.querySelector('#MainContent');
    const banner = main?.querySelector('brand-image-slideshow, slideshow-component, .slideshow, .image-banner, .hero-air10, .black-friday-banner');
    activeBanner = banner;
    header.classList.toggle('header--has-banner', Boolean(banner));
    if (!banner) {
      header.classList.remove('header--over-banner');
      header.style.removeProperty('--banner-header-height');
      header.style.removeProperty('margin-bottom');
      return;
    }
    // Transparency is limited to the top of the page on every viewport.
    header.classList.toggle('header--over-banner', window.scrollY <= 0);
    controller = new AbortController();
    const update = () => {
      frame = null;
      const headerRect = header.getBoundingClientRect();
      // Establish the overlap before testing it; do not depend on another observer's timing.
      const height = `${headerRect.height}px`;
      if (header.style.getPropertyValue('--banner-header-height') !== height) {
        header.style.setProperty('--banner-header-height', height);
      }
      // Keep the first banner physically behind the header. Relying on the
      // stylesheet variable alone can leave a white gap while theme sections,
      // fonts, or the mobile viewport are still settling.
      const overlapMargin = `-${headerRect.height}px`;
      if (header.style.marginBottom !== overlapMargin) {
        header.style.marginBottom = overlapMargin;
      }
      if (banner.style.getPropertyValue('--banner-header-height') !== height) {
        banner.style.setProperty('--banner-header-height', height);
      }
      const bannerRect = banner.getBoundingClientRect();
      header.classList.toggle('header--over-banner',
        window.scrollY <= 0 && bannerRect.height > 0 && bannerRect.bottom >= headerRect.bottom - 1);
    };
    const schedule = () => {
      if (frame == null) frame = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
    window.addEventListener('resize', schedule, { signal: controller.signal });
    window.addEventListener('pageshow', schedule, { signal: controller.signal });
    window.addEventListener('load', schedule, { signal: controller.signal });
    observer = new ResizeObserver(schedule);
    observer.observe(banner);
    observer.observe(header);
    observer.observe(document.body);
    let previous = header.previousElementSibling;
    while (previous) {
      observer.observe(previous);
      previous = previous.previousElementSibling;
    }
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  const scheduleRebind = () => {
    if (rebindFrame != null) return;
    rebindFrame = requestAnimationFrame(() => {
      rebindFrame = null;
      init();
    });
  };
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => document.addEventListener(event, scheduleRebind));

  // Theme dev and section-rendering updates may replace DOM without editor events.
  // Only structural changes involving a section/banner need a fresh binding.
  const relevant = '.shopify-section-header, #MainContent, .shopify-section, brand-image-slideshow, slideshow-component, .slideshow, .image-banner, .hero-air10, .black-friday-banner';
  const mutations = new MutationObserver(records => {
    if (!activeHeader?.isConnected || (activeBanner && !activeBanner.isConnected)) {
      scheduleRebind();
      return;
    }
    const affectsSections = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches(relevant) || node.querySelector(relevant))
    ));
    if (affectsSections) scheduleRebind();
  });
  mutations.observe(document.documentElement, { childList: true, subtree: true });
})();
